/**
 * Created by claudio iozzia on 04/05/2017.
 */
import {EntityError} from "../../../../models/EntityAlert";
import {ISingleOutput} from "../../../../models/ISpec";
import {Ic, IEntityAlert} from "../../../../models/common";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Utils} from "../../../../common/utils";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {calculate_voutUpperBound} from "./acdc__common_validator";
import {Validator_Common} from "../../../../models/validator/validator_common";

export class Validator_AcDc_ViperBuck extends Validator_Common {
  private validatorFn_SingleOutput_Voltage_ViperBuck: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const vOutUpperBound = calculate_voutUpperBound(ic, spec);

    const result = Utils.acceptInRange(_vOut, ic.vout_min, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_ViperBuck: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _iOut = spec.spec.value.output.outputs[o].current;
    const currentUpperBound: number = this.calculate_currentUpperBound(ic, spec.spec.value.output.outputs[o], spec.spec.value.input.min);

    const result = Utils.acceptUpTo(_iOut, currentUpperBound, "Iout", "A");
    return new EntityError(result);
  }

  private calculate_currentUpperBound(ic: Ic, out: ISingleOutput<number>, vinMin_dc: number): number {
    const _IdLim: number = Utils.getFieldValue(ic, "designData.IdLim", 0);
    let maxIoutValue: number = ValueFormatter.scale(0.7 * _IdLim, siPrefix.unit, 2, 'c');
    if (Utils.isValueReal(out.voltage) && Utils.isValueReal(vinMin_dc)) {
      const dMax: number = out.voltage / vinMin_dc;
      // const maxIoutValue:Number = Math.min(IdLim, IdLim*11/10 / Math.sqrt(  2 / (0.97 * 0.5 *(1-dMax) )));

      const maxPower: number = Utils.getFieldValue(ic, "validator.power.max", Number.POSITIVE_INFINITY);

      if (Utils.isValueReal(maxPower) && out.voltage) {
        maxIoutValue = Math.min(maxPower / out.voltage, maxIoutValue);
      }
    }
    const currentUpperBound: number = ValueFormatter.scale(maxIoutValue, siPrefix.unit, 2, 'f');
    return currentUpperBound;
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_ViperBuck].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_ViperBuck].concat(super.singleOutputI());
  }
}
